import { alpha, Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { Close } from '@mui/icons-material';

import { CHATBOT_INTERACTION_TYPES } from 'routes/SearchPerson/SearchFilter/constants';

interface NotificationMessageProps {
  initialNotificationVisible: boolean;
  // eslint-disable-next-line no-unused-vars
  setInitialNotificationVisible: (visible: boolean) => void;
  capitalizeFullName?: string;
  // eslint-disable-next-line no-unused-vars
  setIsChatbotOpen: (type: string) => void;
}

export const NotificationMessage = ({
  initialNotificationVisible,
  setInitialNotificationVisible,
  capitalizeFullName,
  setIsChatbotOpen,
}: NotificationMessageProps) => {
  const { isDesktop } = useScreenSize();
  const theme = useTheme();
  return (
    <Stack
      sx={{
        position: 'absolute',
        top: isDesktop ? 0 : -50,
        right: isDesktop ? 170 : 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '24px',
        zIndex: initialNotificationVisible ? 1200 : -1,
        gap: 1,
        opacity: initialNotificationVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        cursor: 'pointer',
      }}
    >
      <Stack
        component="button"
        sx={{
          background: 'none',
          border: 'none',
          color: theme.palette.text.secondary,
          fontSize: 22,
          cursor: 'pointer',
          lineHeight: 1,
          width: 28,
          height: 28,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background 0.2s',
          backgroundColor: theme.palette.background.paper,
          boxShadow: `0 5px 5px -3px ${alpha(
            theme.palette.success.dark,
            0.2
          )}, 0 8px 10px 1px ${alpha(theme.palette.primary.main, 0.14)} `,

          '&:hover': {
            background: theme.palette?.rats?.light,
          },
        }}
        aria-label="Dismiss"
        onClick={() => {
          setInitialNotificationVisible(false);
        }}
      >
        <Close />
      </Stack>
      <Text
        fontSize={14}
        color="#222"
        variant="caption"
        width="210px"
        sx={{
          background: theme.palette?.background.paper,
          margin: 0,
          padding: '8px 4px 8px 12px',
          boxShadow: `0 5px 5px -3px ${alpha(
            theme.palette.success.dark,
            0.2
          )}, 0 8px 10px 1px ${alpha(theme.palette.primary.main, 0.14)} `,
          borderRadius: '24px',

          '&:hover': {
            backgroundColor: theme.palette?.rats?.light,
          },
        }}
        onClick={() => {
          setIsChatbotOpen(CHATBOT_INTERACTION_TYPES.OPEN);
          setInitialNotificationVisible(false);
        }}
      >
        Need help finding{' '}
        <b>{capitalizeFullName?.trim() ? capitalizeFullName : 'someone'}?</b>
      </Text>
    </Stack>
  );
};
